<template>
  <div class="talentsData">
    <el-form :model="queryInfo" class="ly-header__bg" label-width="100px">
      <el-form-item label="领域类别：">
        <dic-tag-button
          :code.sync="queryInfo.fieldIdName"
          query-name="fieldIdName"
          name="领域类别"
          tag="领域"
          ref="fieldUpdate"
          key="领域类别"
          @onChange="onChange"
        />
      </el-form-item>
    </el-form>
    <div class="bottomCard ly-container__bg">
      <div class="ly_operation" style="margin-bottom: 10px">
        <div class="left">
          <!-- 添加案例 -->
          <el-button @click="addItem" type="primary" icon="el-icon-plus"
            >添加</el-button
          >
          <import-data @fileClick="fileClick" moduleName="领域知识" />
          <el-button @click="multDelete" style="margin:0px">
            批量删除
            <i class="jr-iconjr-icon-delet" />
          </el-button>
          <div class="upload_time">
            <div class="caretTime" @click="uploadTime" style="color:#606266">按上传时间</div>
            <i
              class="el-icon-caret-top"
              :class="[
                queryInfo.columnName == 'company_included_time' && queryInfo.order == 0
                  ? 'isActiveTime1'
                  : 'iconColor',
              ]"
              @click="caretTop"
            />
            <i
              class="el-icon-caret-bottom"
              :class="[
                queryInfo.columnName == 'company_included_time' && queryInfo.order == 1
                  ? 'isActiveTime1'
                  : 'iconColor',
              ]"
              @click="caretBottom"
            />
          </div>
        </div>
        <!-- 搜索框 -->
        <el-input
          placeholder="根据名称、别称、关键词进行全文搜索"
          v-model="queryInfo.dim"
          style="width:470px"
          @change="getSchemes1"
        >
          <template slot="append">
            <div @click="getSchemes1" style="cursor: pointer">搜索</div>
          </template>
        </el-input>
      </div>
      <!-- 表格数据 -->
      <el-table
        class="ly_table"
        :data="dataData"
        :cell-style="{ 'text-align': 'center' }"
        :header-cell-style="{
          background: '#F5F6F7',
          color: '#363E4D',
          'text-align': 'center',
        }"
        @sort-change="sortChange"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="序号" align="center" width="80">
          <template v-slot="scope">
            <span>
              {{
              (queryInfo.pageNum - 1) * queryInfo.pageSize +
              (scope.$index + 1)
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="solutionDataIntegrity" label="数据完整度" sortable="custom" width="120">
          <template v-slot="{ row }">
            <div @click="editTalent(row)" style="cursor: pointer">
              <el-progress type="circle" :percentage="row.integrity" sortable :stroke-width="12"></el-progress>
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <img src="@/assets/img/table.png" alt="没有数据" srcset />
        </template>
        <el-table-column prop="fieldName" label="领域名称">
          <template v-slot="{ row }">
            <div @click="editTalent(row)" style="cursor: pointer">
              <span>{{ row.fieldName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="领域别称">
          <template v-slot="{ row }">
            <div @click="editTalent(row)" style="cursor: pointer">
              <span>{{ row.name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="introduction" label="领域描述" width="400">
          <template slot-scope="scope">
            <div @click="editTalent(scope.row)" style="cursor: pointer">
              <el-popover
                placement="right"
                width="400"
                trigger="hover"
                :content="scope.row.introduction"
              >
                <div slot="reference">
                  <div v-if="(scope.row.introduction !== null) && (scope.row.introduction !== '')">
                    {{scope.row.introduction.substring(0,50)}}
                    <span
                      v-if="scope.row.introduction.length>50"
                    >...</span>
                  </div>
                </div>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="fatherName" label="上级领域"></el-table-column>
        <!-- <el-table-column prop="companyIncludedTime" label="上传时间"></el-table-column> -->
        <el-table-column prop="solutionTechnology" label="是否列为筛选标签" width="140">
          <template v-slot="{ row }">
            <el-switch
              v-model="row.screen"
              active-color="#13ce66"
              inactive-color="#c6c6c6"
              :active-value="1"
              :inactive-value="0"
              @change="btnClick(row)"
            ></el-switch>
          </template>
        </el-table-column>
                <el-table-column prop="createName" label="创建人" align="center" width="80"></el-table-column>
        <el-table-column prop="companyIncludedTime" label="创建时间" align="center" width="120"   :formatter="formatTime"></el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <button-table
              @buttonClick="editTalent(scope.row)"
              content="编辑"
              icon="jr-iconjr-icon-edit"
            />
            <button-table
              @buttonClick="deleteTalent(scope.row.id)"
              content="删除"
              icon="jr-iconjr-icon-delect"
            />
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        :current-page="queryInfo.pageNumber"
        :page-sizes="[10, 30, 50,100]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script src="../../assets/font/iconfont.js"></script>
<script>
import DicTagButton from "@/components/DicTagButtonUpdate.vue";
import UploadFileTalent from "@/components/UploadFileTalent.vue";
import ButtonTable from "../../components/ButtonTable.vue";
import { getFields,editFields,deleteField } from "@/api/field.js";
import DicRadioButton from "@/components/DicRadioButton.vue";
import ImportData from '@/components/ImportData.vue'
import DicCheckboxGroup from "@/components/DicCheckboxGroup.vue";
import { getKnowFieldList } from '@/api/common'
export default {
  components: {
    ButtonTable,
    DicRadioButton,
    DicTagButton,
    DicCheckboxGroup,
    UploadFileTalent,
    ImportData
  },
  created() {
    this.getSchemes()
  },
  mounted() {
    this.fieldCatch()
  },
  mounted(){
    this.fieldCatch()
  },
  mounted(){
    this.fieldCatch()
  },
  data() {
    return {
      // 查询搜索数据
      // 表格数据
      queryInfo: {
        pageSize: 10,
        pageNum: 1,
        order: 1,
        columnName: 'company_update_time',
      },
      dataData: [],
      total: 0,
      // 搜索
      input2: '',
      // 删除
      deleteTalentData: [],
      multipleSelection: [],
      valueI: 0,
    }
  },
  methods: {
    // 按上传时间显示
    async uploadTime() {
      switch (this.valueI) {
        case 0:
          this.queryInfo.columnName = 'company_included_time'
          this.queryInfo.order = 1
          this.valueI++
          break
        case 1:
          this.queryInfo.columnName = 'company_included_time'
          this.queryInfo.order = 0
          this.valueI++
          break
        case 2:
          this.queryInfo.columnName = 'company_update_time'
          this.queryInfo.order = 1
          this.valueI = 0
          break
      }
      this.getSchemes()
    },
    // 浏览人才数据
    getSchemes1() {
      let dim = this.queryInfo.dim
      this.queryInfo = {
        dim: dim,
        pageSize: 10,
        pageNum: 1,
        order: 1,
      }
      this.getSchemes()
    },
    async getSchemes() {
      const res = await getFields(this.queryInfo)
      if (res.code === 200) {
        this.dataData = res.data.list
        // this.dataData = this.dataData.forEach(item => {
        //   item.filelist = item.knowField.map(item1 => {
        //     return item1
        //   })
        // })
        this.total = res.data.total
        this.dataData.forEach((el) => {
          if (!el.integrity) {
            el.integrity = 0
          }
        })
      }
    },
    // 按姓名搜索
    // 分页
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.getSchemes()
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage
      this.getSchemes()
    },
    // 选中表格数据并赋值id选项
    handleSelectionChange(val) {
      this.multipleSelection = val.map((item) => {
        return item.id
      })
    },
    onChange() {
      this.$refs.fieldUpdate.getDicData()
    },
    onChange(){
      this.$refs.fieldUpdate.getDicData();
    },
    onChange(){
      this.$refs.fieldUpdate.getDicData();
    },
    // 跳转编辑页面
    editTalent(data) {
      // this.$router.push({
      //   name: 'fieldInfo',
      //   params: {
      //     newsData: data.id,
      //     personType: 1,
      //   },
      // })
      let text = this.$router.resolve({
        path: "/knowledgeData/field/fieldInfo",
        query: {
          newsData: data.id,
          personType: 1,
        },
      });
      window.open(text.href, "_blank");
    },
    // 单个删除
    deleteTalent(id) {
      this.deleteTalentData[0] = id
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示').then(
        async () => {
          const res = await deleteField(this.deleteTalentData)
          if (res.code == 200) {
            this.getSchemes()
            this.deleteTalentData = []
            this.$message.success('删除成功')

            // 更新session
            const res1 = await getKnowFieldList()
            res1.data = JSON.parse(
              JSON.stringify(res1.data).replace(/fieldName/g, 'codeName')
            )
            sessionStorage.setItem('field', JSON.stringify(res1.data))
          }
        }
      )
    },
    // 批量删除
    multDelete() {
      if (this.multipleSelection.length > 1) {
        this.$confirm('此操作将永久删除批量文件, 是否继续?', '提示').then(
          async () => {
            const res = await deleteField(this.multipleSelection)
            if (res.code == 200) {
              this.getSchemes()
              this.multipleSelection = []
              this.$message.success('删除成功')

              // 更新seesion
              const res1 = await getKnowFieldList()
              res1.data = JSON.parse(
                JSON.stringify(res1.data).replace(/fieldName/g, 'codeName')
              )
              sessionStorage.setItem('field', JSON.stringify(res1.data))
            }
          }
        )
      } else {
        this.$message.error('批量删除必须大于一条')
      }
    },
    handleClose() {
      this.$refs.checkboxEnterprise.clear()
    },
    addItem() {
      this.$router.push({
        name: 'fieldInfo',
        query: {
          personCode: '',
        },
      })
    },
    fileClick() {
      this.getSchemes()
    },
    fileClick() {
      this.getSchemes()
    },
    // 正序
    caretTop() {
      this.queryInfo.order = 1
      this.getSchemes()
    },
    // 倒序
    caretBottom() {
      this.queryInfo.order = 0
      this.getSchemes()
    },
    formatString(val) {
      if (!val) {
        return []
      } else {
        return val.split(',')
      }
    },
    async btnClick(data) {
      const res = await editFields(data)
      this.$message.success('修改成功')
      this.getSchemes()
      const res1 = await getKnowFieldList()
      res1.data = JSON.parse(
        JSON.stringify(res1.data).replace(/fieldName/g, 'codeName')
      )
      sessionStorage.setItem('field', JSON.stringify(res1.data))
      this.$refs.fieldUpdate.options = res1.data;
      this.$refs.fieldUpdate.changeVal()
    },
    async fieldCatch(){
      const res1 = await getKnowFieldList()
      this.$refs.fieldUpdate.options = res1.data;
      this.$refs.fieldUpdate.changeVal()
    },
    sortChange(column) {
      this.pageNum = 1
      if (column.prop === 'solutionDataIntegrity') {
        this.queryInfo.columnName = 'integrity'
        if (column.order === 'ascending') {
          this.queryInfo.order = 0
        } else if (column.order === 'descending') {
          this.queryInfo.order = 1
        } else {
          this.queryInfo.order = 1
          this.queryInfo.columnName = 'company_update_time'
        }
      }
      this.getSchemes()
    },
    formatTime(row, column) {
        const date = new Date(row[column.property])
        return date.getFullYear() + '-' +
         (date.getMonth()+1)+ '-' +
         date.getDate()
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-card__body {
  padding: 10px;
}
// 下半el-card部分
.left {
  display: flex;
  align-items: center;
  // position: relative;
  .upload_time {
    position: relative;
    color: #1f212b;
    font-size: 14px;
    margin-left: 20px;
    .el-icon-caret-top,
    .el-icon-caret-bottom {
      position: absolute;
      right: -16px;
      color: #1f212b;
    }
    .el-icon-caret-top {
      top: 0px;
    }
    .el-icon-caret-bottom {
      top: 6px;
    }
  }
}
/deep/ .el-input-group__append {
  background: #1e9fff;
  color: #fff;
  border: 1px solid #1e9fff;
}
.el-dropdown-menu {
  text-align: center;
  border: 1px solid #dbdbdb;
  width: 176px;
  height: 74px;
}
/deep/ .upload {
  padding: 12px 20px;
}
/deep/ .el-dialog__header {
  text-align: center;
  font-weight: 700;
}
.caretTime {
  cursor: pointer;
}
.isActiveTime1 {
  color: #1e9fff !important;
}
.iconColor {
  color: #c0c4cc !important;
}
</style>
